// src/pages/company-admin/CompanyProfilePage.tsx
import React from 'react';

const CompanyProfilePage: React.FC = () => {
  // TODO: 현재 로그인 사용자의 회사 정보 fetch
  return (
    <div className="p-4 space-y-4">
      <h2 className="text-sm font-semibold text-gray-800 mb-2">회사 기본 정보</h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-xs text-gray-500 mb-1">Company Name</label>
          <input
            className="w-full rounded border border-gray-300 px-2 py-1.5 text-sm"
            defaultValue=""
            placeholder="예: ABC EPC Co., Ltd."
          />
        </div>
        <div>
          <label className="block text-xs text-gray-500 mb-1">Code</label>
          <input
            className="w-full rounded border border-gray-300 px-2 py-1.5 text-sm"
            defaultValue=""
            placeholder="예: EPC001"
          />
        </div>
        <div>
          <label className="block text-xs text-gray-500 mb-1">Country</label>
          <input
            className="w-full rounded border border-gray-300 px-2 py-1.5 text-sm"
            defaultValue=""
            placeholder="예: Korea"
          />
        </div>
        <div>
          <label className="block text-xs text-gray-500 mb-1">Timezone</label>
          <input
            className="w-full rounded border border-gray-300 px-2 py-1.5 text-sm"
            defaultValue="Asia/Seoul"
          />
        </div>
      </div>

      <div className="pt-2">
        <button className="rounded-lg bg-sky-700 text-white px-4 py-1.5 text-xs hover:bg-sky-800">
          변경 사항 저장
        </button>
      </div>
    </div>
  );
};

export default CompanyProfilePage;
